import {Component} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '@core/reducers';
import {CoreActions} from '@core/store';

@Component({
    selector: 'app-user-management-container',
    templateUrl: './user-management-container.component.html',
    styleUrls: ['./user-management-container.component.scss']
})
export class UserManagementContainerComponent {
    constructor(private store: Store<AppState>) {
        this.store.dispatch(CoreActions.GetLoggedUserData());
    }
}
